"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
document.addEventListener('DOMContentLoaded', function () {
    const menuItems = document.querySelectorAll('.nav__link');
    const menu = document.getElementById('navbarMenu');
    const closeButton = document.querySelector('.nav__close');
    const menuToggle = document.querySelector('.nav__toggle');
    function closeAllDropdowns() {
        const allDropdowns = document.querySelectorAll('.nav__dropdown');
        const allModals = document.querySelectorAll('.nav__modal');
        const allArrows = document.querySelectorAll('.nav__arrow');
        allDropdowns.forEach(function (dropdown) {
            dropdown.classList.remove('is-open');
        });
        allModals.forEach(function (modal) {
            modal.classList.remove('is-open');
        });
        allArrows.forEach(function (arrow) {
            arrow.classList.remove('nav__arrow--rotated');
        });
        const activeLinks = document.querySelectorAll('.nav__link.is-active');
        activeLinks.forEach(function (link) {
            link.classList.remove('is-active');
        });
    }
    function scrollToTopOfElement(element) {
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }
    function handleDropdownToggle() {
        menuItems.forEach(function (toggle) {
            toggle.removeEventListener('click', dropdownClickHandler);
            if (window.innerWidth <= 991) {
                toggle.addEventListener('click', dropdownClickHandler);
            }
        });
    }
    function dropdownClickHandler(e) {
        e.preventDefault();
        const dropdown = this.nextElementSibling;
        const modal = this.closest('.nav__modal');
        if (modal) {
            if (modal.classList.contains('is-open')) {
                modal.classList.remove('is-open');
                this.classList.remove('is-active');
            }
            else {
                closeAllDropdowns();
                modal.classList.add('is-open');
                this.classList.add('is-active');
            }
        }
        else if (dropdown) {
            if (dropdown.classList.contains('is-open')) {
                dropdown.classList.remove('is-open');
                this.classList.remove('is-active');
                const arrow = this.querySelector('.nav__arrow');
                arrow === null || arrow === void 0 ? void 0 : arrow.classList.remove('nav__arrow--rotated');
            }
            else {
                closeAllDropdowns();
                dropdown.classList.add('is-open');
                this.classList.add('is-active');
                const arrow = this.querySelector('.nav__arrow');
                arrow === null || arrow === void 0 ? void 0 : arrow.classList.add('nav__arrow--rotated');
            }
            if (!(menu === null || menu === void 0 ? void 0 : menu.classList.contains('is-open'))) {
                menu === null || menu === void 0 ? void 0 : menu.classList.add('is-open');
            }
            scrollToTopOfElement(this);
        }
        else {
            window.location.href = this.href;
        }
    }
    closeButton === null || closeButton === void 0 ? void 0 : closeButton.addEventListener('click', function () {
        menu === null || menu === void 0 ? void 0 : menu.classList.remove('is-open');
        closeAllDropdowns();
    });
    menuToggle === null || menuToggle === void 0 ? void 0 : menuToggle.addEventListener('click', function () {
        menu === null || menu === void 0 ? void 0 : menu.classList.toggle('is-open');
    });
    document.addEventListener('click', function (e) {
        const target = e.target;
        if (!(menu === null || menu === void 0 ? void 0 : menu.contains(target)) && !target.closest('.nav__toggle') && !target.closest('.nav__modal')) {
            menu === null || menu === void 0 ? void 0 : menu.classList.remove('is-open');
            closeAllDropdowns();
        }
    });
    window.addEventListener('resize', function () {
        handleDropdownToggle();
    });
    handleDropdownToggle();
});
